import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { register } from './pwa/register'
import { App } from './ui/App'
import { SettingsProvider } from './ui/settings'
import './ui/styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('kein #root im Dokument')
createRoot(root).render(
  <StrictMode>
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </StrictMode>,
)

register()
